<button hidden="true" #statusButton (click)="changeStatus()"></button>
<div class="row pt-5" *ngIf="modParameter">

  <div class="col-md-12 col-xl-4">
    <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 0"
      [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 0" (click)="switchTo(0)">
      Cantidades y<br>Reglamento
    </button>
  </div>

  <div class="col-md-6 mt-2 col-xl-4 mt-xl-0">
    <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 1"
      [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 1" (click)="switchTo(1)">
      Fechas De<br>Inscripción
    </button>
  </div>

  <div class="col-md-6 mt-2 col-xl-4 mt-xl-0">
    <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 2"
      [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 2" (click)="switchTo(2)">
      Fechas De<br>Retiro
    </button>
  </div>

</div>

<div class="row pt-2 pb-2" *ngIf="modParameter">

  <div class="col-md-12 mt-2 col-xl-4 mt-xl-0">
    <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 3"
      [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 3" (click)="switchTo(3)">
      Compañías<br>Incluidas
    </button>
  </div>

  <div class="col-md-6 mt-2 col-xl-4 mt-xl-0">
    <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 5"
      [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 5" (click)="switchTo(5)">
      Contratos<br>Incluidos
    </button>
  </div>

  <div class="col-md-6 mt-2 col-xl-4 mt-xl-0">
    <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 4"
      [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 4" (click)="switchTo(4)">
      Departamentos<br>Excluidos
    </button>
  </div>

</div>
<div class="row pb-5 border-bottom" *ngIf="modParameter">
  <div class="col-md-6 mt-2 col-xl-4 mt-xl-0">
    <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 6"
      [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 6" (click)="switchTo(6)">
      Fechas de<br>Aportaciones Extraordinarias
    </button>
  </div>

  <div class="col-md-6 mt-2 col-xl-4 mt-xl-0" *ngIf="originalDRDistributionValue">
    <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 7"
      [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 7" (click)="switchTo(7)">
      Reparto de<br>rendimientos
    </button>
  </div>

  <div class="col-md-6 mt-2 col-xl-4 mt-xl-0">
    <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 8"
      [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 8" (click)="switchTo(8)">
      Rendimientos<br>&nbsp;
    </button>
  </div>
</div>

<div class="p-3" *ngIf="contentLocation.savingParametersIndex == 0">

  <div class="row">

    <div class="col-md-4">

      <mat-form-field>

        <span matPrefix>$&nbsp;</span>

        <input matInput placeholder="Cantidad Mínima Semanal:" type="number" min="0"
          [(ngModel)]="modParameter.savingParameter.weeklyMin" #weeklyMin="ngModel" [min]="1" [max]="1000000"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57" id="weeklyMin" required>

        <mat-error *ngIf="weeklyMin.invalid && weeklyMin?.errors.required">Cantidad Mínima Semanal es Requerida.</mat-error>
        <mat-error *ngIf="weeklyMin?.errors?.min">La cantidad debe de ser mayor a 1.</mat-error>
        <mat-error *ngIf="weeklyMin?.errors?.max">La cantidad debe de ser menor a 1,000,000 pesos.</mat-error>

      </mat-form-field>

    </div>

    <div class="col-md-4">

      <mat-form-field>

        <span matPrefix>$&nbsp;</span>

        <input matInput placeholder="Cantidad Mínima Catorcena:" type="number" min="0"
          [(ngModel)]="modParameter.savingParameter.biWeeklyMin" #biWeeklyMin="ngModel" [min]="1" [max]="1000000"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57" required>

        <mat-error *ngIf="biWeeklyMin.invalid && biWeeklyMin?.errors?.required">Cantidad Mínima Catorcena es Requerida.
        </mat-error>
        <mat-error *ngIf="biWeeklyMin?.errors?.min">La cantidad debe de ser mayor a 1.</mat-error>
        <mat-error *ngIf="biWeeklyMin?.errors?.max">La cantidad debe de ser menor a 1,000,000 pesos.</mat-error>

      </mat-form-field>

    </div>

    <div class="col-md-4">

      <mat-form-field>

        <span matPrefix>$&nbsp;</span>

        <input matInput placeholder="Salario Mínimo General:" type="number" min="0" [(ngModel)]="modParameter.savingParameter.UMA"
          #umaValue="ngModel" [min]="1" [max]="1000000" required>

        <mat-error *ngIf="umaValue.invalid && umaValue?.errors?.required">Salario Mínimo General</mat-error>
        <mat-error *ngIf="umaValue?.errors?.min">El Salario Mínimo General debe de ser mayor a 1.</mat-error>
        <mat-error *ngIf="umaValue?.errors?.max">El Salario Mínimo General debe de ser menor a 1,000,000 pesos.</mat-error>

      </mat-form-field>

    </div>

  </div>

  <div class="row">

    <div class="col-md-12">

      <div class="file-upload p-3 border">

        <label>
          <div class="icon my-5">
            <i class="material-icons">file_upload</i>
          </div>
          <input type="file" (change)="detectFiles($event, 'fileSura')" multiple>
        </label>

        <h6 class="my-5 text-center">
          Reglamento:

          <a *ngIf="modParameter.savingParameter.fileUploaded.downloadURL; else noURL"
            href="{{modParameter.savingParameter.fileUploaded.downloadURL}}" target="_blank">
            {{modParameter.savingParameter.fileUploaded.name}}
          </a>

          <ng-template #noURL>

            <span *ngIf="modParameter.savingParameter.fileUploaded.name; else noFileSelected">
              {{modParameter.savingParameter.fileUploaded.name}}
            </span>

            <ng-template #noFileSelected>
              <span>
                No se ha seleccionado ningún archivo
              </span>
            </ng-template>

          </ng-template>

        </h6>

      </div>

    </div>

  </div>

</div>

<div class="p-3" *ngIf="contentLocation.savingParametersIndex == 1">

  <div class="mt-5 row">

    <div class="col-md-4">
      <mat-form-field>
        <input matInput [matDatepicker]="inicioDeCicloPicker" placeholder="Inicio:"
          (dateChange)="setRegistrationDate('starts', $event)" [value]="newRegistrationDate.startDate">
        <mat-datepicker-toggle matSuffix [for]="inicioDeCicloPicker"></mat-datepicker-toggle>
        <mat-datepicker #inicioDeCicloPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field>
        <input matInput [matDatepicker]="finDeCicloPicker" placeholder="Fin:"
          (dateChange)="setRegistrationDate('ends', $event)" [value]="newRegistrationDate.endDate"
          [min]="newRegistrationDate.startDate" [disabled]="!newRegistrationDate.startDate">
        <mat-datepicker-toggle matSuffix [for]="finDeCicloPicker"></mat-datepicker-toggle>
        <mat-datepicker #finDeCicloPicker [disabled]="!newRegistrationDate.startDate"></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="col-md-4 center-vertically">
      <mat-checkbox [(ngModel)]="newRegistrationDate.indeterminate" labelPosition="before"
        (change)="setDateAsIndeterminate($event)">Sin
        fecha fin</mat-checkbox>
    </div>

  </div>


  <div class="row">
    <div class="col-md-4 offset-md-8 center-vertically">
      <button class="btn-block" mat-raised-button color="primary" (click)="addRegistrationDate()">Añadir Fechas</button>
    </div>
  </div>

  <div class="my-5 row border-top" *ngIf="modParameter.savingParameter.registrationDates.length > 0">
    <div class="col-md-12">

      <mat-table #registrationDatesTable class="table" [dataSource]="modParameter.savingParameter.registrationDates">

        <ng-container matColumnDef="Inicio">
          <mat-header-cell *matHeaderCellDef> Inicio </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.startDate | date: 'mediumDate'}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Fin">
          <mat-header-cell *matHeaderCellDef> Fin </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.endDate ? (element.endDate | date: 'mediumDate') :
              ''}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="FinIndeterminado">
          <mat-header-cell *matHeaderCellDef> Fin Indeterminado </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-checkbox [(ngModel)]="element.indeterminate" [disabled]="true">Sin fecha fin</mat-checkbox>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="active">
          <mat-header-cell *matHeaderCellDef> Fecha Activa </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-checkbox [(ngModel)]="element.active" [disabled]="false">Fecha Activa</mat-checkbox>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="delete" class="center-text">
          <mat-header-cell *matHeaderCellDef><span>Eliminar</span></mat-header-cell>
          <mat-cell *matCellDef="let index = index">
            <button mat-icon-button color="warn" (click)="deleteRegistrationDate(index)">
              <mat-icon aria-label="Delete">delete_outline</mat-icon>
            </button>

          </mat-cell>
        </ng-container>

        <mat-header-row mat-header-row *matHeaderRowDef="displayedRegistrationDatesColumns"></mat-header-row>
        <mat-row mat-row *matRowDef="let row; columns: displayedRegistrationDatesColumns;"></mat-row>

      </mat-table>

    </div>
  </div>

</div>

<div class="p-3" *ngIf="contentLocation.savingParametersIndex == 2">

  <div class="mt-5 row">

    <div class="col-md-4">

      <mat-form-field>
        <input matInput [matDatepicker]="startWithdrawPicker" placeholder="Inicio:"
          (dateChange)="setWithdrawDate('starts', $event)" [value]="newWithdrawDate.startDate">
        <mat-datepicker-toggle matSuffix [for]="startWithdrawPicker"></mat-datepicker-toggle>
        <mat-datepicker #startWithdrawPicker></mat-datepicker>
      </mat-form-field>

    </div>

    <div class="col-md-4">

      <mat-form-field>
        <input matInput [matDatepicker]="endWithdrawPicker" placeholder="Fin:"
          (dateChange)="setWithdrawDate('ends', $event)" [value]="newWithdrawDate.endDate"
          [disabled]="!newWithdrawDate.startDate" [min]="newWithdrawDate.startDate">
        <mat-datepicker-toggle matSuffix [for]="endWithdrawPicker"></mat-datepicker-toggle>
        <mat-datepicker #endWithdrawPicker [disabled]="!newWithdrawDate.startDate"></mat-datepicker>
      </mat-form-field>

    </div>

    <div class="col-md-4 bottom-vertically">

      <button class="btn-block" mat-raised-button color="primary" (click)="addWithdrawDate()">Añadir Fechas</button>

    </div>
  </div>

  <div class="my-5 row border-top" *ngIf="modParameter.savingParameter.withdrawDates.length > 0">
    <div class="col-md-12">

      <mat-table mat-table #withdrawDatesTable class="table" [dataSource]="modParameter.savingParameter.withdrawDates">


        <ng-container matColumnDef="Inicio">
          <mat-header-cell mat-header-cell *matHeaderCellDef> Inicio </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element"> {{element.startDate | date: 'mediumDate'}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Fin">
          <mat-header-cell mat-header-cell *matHeaderCellDef> Fin </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element"> {{element.endDate ? (element.endDate | date: 'mediumDate') :
              ''}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="active">
          <mat-header-cell mat-header-cell *matHeaderCellDef> Fecha Activa </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element">
            <mat-checkbox [(ngModel)]="element.active">Fecha Activa</mat-checkbox>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="delete" class="center-text">
          <mat-header-cell *matHeaderCellDef><span>Eliminar</span></mat-header-cell>
          <mat-cell *matCellDef="let index = index">
            <button mat-icon-button color="warn" (click)="deleteWithdrawDate(index)">
              <mat-icon aria-label="Delete">delete_outline</mat-icon>
            </button>

          </mat-cell>
        </ng-container>

        <mat-header-row mat-header-row *matHeaderRowDef="displayedWithdrawDatesColumns"></mat-header-row>
        <mat-row mat-row *matRowDef="let row; columns: displayedWithdrawDatesColumns;"></mat-row>

      </mat-table>

    </div>
  </div>

</div>

<div class="p-3" *ngIf="contentLocation.savingParametersIndex == 3">

  <div class="row">

    <div class="col-md-12">

      <mat-table #companiesTable class="table" [dataSource]="logicService.dataManager.generalDataLoader.companies">


        <ng-container matColumnDef="companyID">
          <mat-header-cell mat-header-cell *matHeaderCellDef> ID </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element"> {{element.companyID}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="companyName">
          <mat-header-cell mat-header-cell *matHeaderCellDef> Nombre de la Compañía </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element"> {{element.companyName}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="taxationIdentificationNumber">
          <mat-header-cell mat-header-cell *matHeaderCellDef> Documento Legal </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element"> {{element.taxationIdentificationNumber}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="select">
          <mat-header-cell mat-header-cell *matHeaderCellDef>
            Incluir Compañía
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selectionCompanies.toggle(row) : null"
              [checked]="selectionCompanies.isSelected(row)"></mat-checkbox>
          </mat-cell>
        </ng-container>

        <mat-header-row mat-header-row *matHeaderRowDef="displayedCompanyColumns"></mat-header-row>
        <mat-row mat-row *matRowDef="let row; columns: displayedCompanyColumns;"></mat-row>
      </mat-table>

    </div>

  </div>

</div>

<div class="p-3" *ngIf="contentLocation.savingParametersIndex == 4">

  <div class="row">

    <div class="col-md-12">

      <mat-table #departmentTable class="table" [dataSource]="logicService.dataManager.generalDataLoader.departments">

        <ng-container matColumnDef="departmentID">
          <mat-header-cell mat-header-cell *matHeaderCellDef> ID </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element"> {{element.departmentID}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="departmentName">
          <mat-header-cell mat-header-cell *matHeaderCellDef> Nombre del Departamento </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element"> {{element.departmentName}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="select">
          <mat-header-cell mat-header-cell *matHeaderCellDef>
            Incluir Departamento
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selectionDepartments.toggle(row) : null"
              [checked]="selectionDepartments.isSelected(row)"></mat-checkbox>
          </mat-cell>
        </ng-container>

        <mat-header-row mat-header-row *matHeaderRowDef="displayedDepartmentColumns"></mat-header-row>
        <mat-row mat-row *matRowDef="let row; columns: displayedDepartmentColumns;"></mat-row>

      </mat-table>

    </div>

  </div>

</div>

<div class="p-3" *ngIf="contentLocation.savingParametersIndex == 5">

  <div class="row">

    <div class="col-md-12">

      <mat-table #departmentTable class="table" [dataSource]="logicService.dataManager.generalDataLoader.contracts">

        <ng-container matColumnDef="contractID">
          <mat-header-cell mat-header-cell *matHeaderCellDef> ID Contrato </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element"> {{element.contractID}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="description">
          <mat-header-cell mat-header-cell *matHeaderCellDef> Tipo Contrato </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element"> {{element.description}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="select">
          <mat-header-cell mat-header-cell *matHeaderCellDef>
            Incluir Contrato
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selectionContracts.toggle(row) : null"
              [checked]="selectionContracts.isSelected(row)"></mat-checkbox>
          </mat-cell>
        </ng-container>

        <mat-header-row mat-header-row *matHeaderRowDef="displayedContractColumns"></mat-header-row>
        <mat-row mat-row *matRowDef="let row; columns: displayedContractColumns;"></mat-row>

      </mat-table>

    </div>

  </div>

</div>
<div class="p-3" *ngIf="contentLocation.savingParametersIndex == 6">

  <app-ps-parameters-contribution [modParameter]="modParameter"></app-ps-parameters-contribution>
  
</div>

<div *ngIf="contentLocation.savingParametersIndex == 7">

  <div *ngIf="iRStatus === 'accumulating'" class="row">
    <h6 class="col mt-5 mb-5" style="text-align: center;">Cálculando rendimientos...</h6>
  </div>

  <div *ngIf="iRStatus === 'creatingFile'" class="row">
    <h6 class="col mt-5 mb-5" style="text-align: center;">Generando archivo de validación</h6>
  </div>

  <div *ngIf="iRStatus === 'fileCreated'">
    <h6 class="col mt-5 mb-5" style="text-align: center;">Archivo de validación generado</h6>
    <div class="row mb-5">
      <div class="col-md-3"></div>
      <button *ngIf="iRFileLink" class="col-md-6 btn btn-block btn-primary" (click)="downloadIRFile()">DESCARGAR ARCHIVO</button>
      <div class="col-md-3"></div>

    </div>
    <div class="row">
      <div class="col-md-4 offset-md-4">
          <button (click)="cancelInvestmentReturn(true)" class="btn btn-block btn-outline-secondary">Cancelar repartición</button>
      </div>
      <div class="col-md-4">
          <button (click)="distributeDR()" class="btn btn-block btn-primary">Repartir rendimientos</button>
      </div>
    </div>
  </div>

  <div *ngIf="iRStatus === 'distributingDR'">
    <h6 class="col mt-5 mb-5" style="text-align: center;">Repartiendo rendimientos...</h6>
  </div>

  <div *ngIf="iRStatus === 'savingRecordCards'">
    <h6 class="col mt-5 mb-5" style="text-align: center;">Guardando fichas ...</h6>
  </div>

  <div *ngIf="iRStatus === 'finished'">
    <h6 class="col mt-5 mb-5" style="text-align: center;">Repartición terminada</h6>
  </div>

  <div *ngIf=" ['recordCardError','m4HttpCodeError','m4StatusError','m4RequestError'].includes(iRStatus)">
    <h6 class="col mt-5 mb-5" style="text-align: center;"> {{iRStatus}} Ha ocurrido una intermitencia, favor de contactar al administrador</h6>
  </div>

  <div *ngIf="!iRStatus">
    <mat-form-field class="col-md-12">
      <span matPrefix>$&nbsp;</span>
  
      <input matInput placeholder="Rendimiento:" type="number" [(ngModel)]="revenueAmount" required>
    </mat-form-field>
  
    <div class="row">
      <div class="col-md-4 offset-md-4">
          <button (click)="cancelInvestmentReturn()" class="btn btn-block btn-outline-secondary">Cancelar</button>
      </div>
      <div class="col-md-4">
          <button (click)="calculateDR()" class="btn btn-block btn-primary">Calcular</button>
      </div>
    </div>
  </div>

</div>

<div *ngIf="contentLocation.savingParametersIndex == 8">
  <mat-radio-group [(ngModel)]="modParameter.hasDRDistribution" class="radio-group">
    <mat-radio-button [value]="true">Habilitar distribución de rendimientos</mat-radio-button>
    <mat-radio-button [value]="false">Deshabilitar distribución de rendimientos</mat-radio-button>
  </mat-radio-group>
</div>